import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-faq-component',
	templateUrl: './faq-component.component.html',
	styleUrls: ['./faq-component.component.scss'],
})
export class FaqComponentComponent implements OnInit {
	@Input() isWhiteText: boolean = true;
	@Input() bannerClass: string = 'bannerdrk';
	@Input() textWhite: string = 'text-white';
	@Input() h1text: string = '';
	@Input() brdtp: string = '';

	constructor() {}

	ngOnInit(): void {}
}
